"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var githash = '367b4d2';
exports.default = githash;
